// 基本方案码表
export const planList = [
  { code: "1", name: "黄金计划" },
  { code: "2", name: "铂金计划" },
  { code: "3", name: "钻石计划" },
  { code: "4", name: "星耀计划" },
]

// 保障范围码表
export const rangeList = [
  { code: "ZGDL", name: "中国大陆" },
  { code: "DZG", name: "大中华" },
  { code: "QQCM", name: "全球除美加" },
  { code: "QQ", name: "全球" },
]

// 医院涵盖范围码表
export const hosRangeList = [
  { code: "001", name: "仅公立医院" },
  { code: "002", name: "公立医院及非昂贵私立医院" },
  { code: "003", name: "包含昂贵" },
]

// 免赔额码表
export const mpList = [
  { code: "0", name: "0" },
  { code: "10000", name: "10,000" },
  { code: "20000", name: "20,000" },
]

// 常驻地区码表
export const areaList = [
  { code: "0", name: "常驻中国大陆" },
  { code: "1", name: "常驻非中国大陆" },
]

// 体检码表
export const tjList = [
  { code: "0", name: "0" },
  { code: "1000", name: "1,000" },
  { code: "2000", name: "2,000" },
]

// 牙科码表
export const ykList = [
  { code: "0", name: "0" },
  { code: "3000", name: "3,000" },
  { code: "5000", name: "5,000" },
]

// 年龄段
export const ageList = [
  "0-2", "3-7", "8-17", "18-24", "25-29", "30-34", "35-39", "40-44", "45-49", "50-54", "55-59", "60-64"
]

// 公司码表
export const companyCode = [
  {code: "0", name: "都邦保险有限公司", fullName: "都邦财产保险股份有限公司(MGU)-DUBANG"},
  {code: "1", name: "人民财产保险天津分公司", fullName: "中国人民财产保险股份有限公司天津市分公司(MGU)-BS077"},
]